import { render, staticRenderFns } from "./sixModal.vue?vue&type=template&id=004bf984&scoped=true&"
import script from "./sixModal.vue?vue&type=script&lang=js&"
export * from "./sixModal.vue?vue&type=script&lang=js&"
import style0 from "./sixModal.vue?vue&type=style&index=0&id=004bf984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004bf984",
  null
  
)

export default component.exports